import React from "react";
import { assets } from "../assets/assets_frontend/assets";
const Contact = () => {
  return (
    <div>
      <h1 className="text-2xl text-center ">
        contact<span className="font-bold text-primary"> us</span>
      </h1>
      <div className="flex flex-col gap-8 p-5 justify-center items-center md:flex-row">
        <img
          className="w-full rounded-xl max-w-[300px] "
          src={assets.contact_image}
          alt="mdsfk"
        />
        <div className="flex flex-col justify-center gap-3">
          <h1 className="text-xl font-semibold">our office</h1>
        <div>
          <p>Lorem ipsum dolor sit.
          </p>
           <p>Lorem ipsum dolor sit.
          </p>
        </div>
        <div>
            <p>tel:687667786</p>
            <p>email:ebraheemgaber222gmail.com</p>
        </div>
       <div>
         <h1 className="font-semibold text-xl">careers prescripto</h1>
         <p>Lorem ipsum dolor sit amet consectetur.</p>
       </div>
          <button onClick={()=>{window.alert("thre isnt any jobs right now")}} className="border  rounded-lg  font-medium w-36 shadow-xl px-3 py-3 hover:bg-primary duration-200 transition-all ">explore jobs</button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
